<template>
    <MazPhoneNumberInput v-model="phoneNumber" default-country-code="US" show-country-selector show-flags show-dial-code
        @update:modelValue="updateValue" :translations="{
            countrySelector: {
                placeholder: 'Código de país',
                error: 'País no válido',
                searchPlaceholder: 'Buscar país',
            },
            phoneInput: {
                placeholder: 'Número de teléfono',
                example: 'Ejemplo: (123) 456-7890',
            },
        }" />
</template>

<script setup>
import { ref, watch } from 'vue';
import 'maz-ui/styles'
import MazPhoneNumberInput from 'maz-ui/components/MazPhoneNumberInput'

const props = defineProps({
    context: {
        type: Object,
        required: true,
    },
});

const phoneNumber = ref(props.context._value || '');

const updateValue = (val) => {
    phoneNumber.value = val;
    props.context.node.input(val);
};

watch(phoneNumber, (newVal) => {
    props.context.node.input(newVal);
});
</script>
